import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.apipath + '/interaction-survey');

export const interactionSurvey = {
	getCanBindActivityList(surveyId, params) {
		return http.get(`/activityList/${surveyId}`, { params });
	},
	boundActivityList(surveyId, body) {
		return http.post(`/boundActivity/${surveyId}`, body);
	},
    cancelBoundActivity(bindId) {
        return http.delete(`/cancel/${bindId}`);
    },
};
